import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { registerNavigateTo, unregisterNavigateTo } from 'webapp/utils/native-bridge';

export default class MobileRoute extends Route {
	@service declare router: Service.Router;
	@service('navigation') declare navigationService: Service.Navigation;

	override beforeModel(): Promise<unknown> {
		document.body.id = 'page-mobile';

		return this.navigationService.initialRequestsPromise;
	}

	override activate(): void {
		registerNavigateTo(this.router);
	}

	override deactivate(): void {
		unregisterNavigateTo();
	}
}
